module.exports = __webpack_public_path__ + "media/img/testimonial/ying-c929dac50265692345d534854ecf28b5.png";